export default "__VITE_ASSET__izVT7X4v__"